import { get } from 'lib/actionHelpers.js';

export const fetchMilestoneGraphData = (query, callback) => {
  return get(`/reporting/summary/milestone-funnel`, {
    query,
    action: 'FETCH_MILESTONE_GRAPH_DATA',
    callback,
  });
};
